<div class="app-shell">

    <!--
        Sidebar:
        - En /home: width fijo 260px.
        - En otras rutas: width 70px (colapsado). Al hacer hover sobre TODA el área
          del sidebar (incluyendo iconos), se expande a 260px sobre el contenido.

        Los listeners de mouseenter/mouseleave van en el <aside> y NO se interrumpen
        por los hijos porque mouseenter/mouseleave NO bubblean (a diferencia de
        mouseover/mouseout). Eso es exactamente lo que necesitamos.
    -->
    <aside class="sidebar"
           [class.expanded]="isExpanded()"
           [class.fixed-mode]="isHomeRoute()"
           (mouseenter)="onSidebarMouseEnter()"
           (mouseleave)="onSidebarMouseLeave()">

        <div class="sidebar-header">
            <!-- Mismo logo que la pantalla de acceso, para que la marca sea
                 una sola en toda la app. Sustituye al icono `medical_services`
                 y al par de líneas de texto que había aquí. -->
            <img src="assets/images/logo_epione_colors.png" alt="Epione" class="logo-mark" />
        </div>

        <!-- Navigation -->
        <nav class="sidebar-nav">
            @if (showNoRoleMessage()) {
                <div class="no-role-warning">
                    <mat-icon>lock_outline</mat-icon>
                    <p class="no-role-title">Acceso restringido</p>
                    <span class="no-role-text">
                        Tu usuario no tiene un rol asignado. Contacta al responsable
                        del sistema para que te asigne uno y puedas acceder a los módulos.
                    </span>
                </div>
            } @else {
                @for (entry of visibleModules(); track entry.id) {
                    @if (isGroup(entry)) {
                        <!-- Grupo expandible (Inventarios, Base Instalada, etc.) -->
                        <div class="nav-group" [class.expanded]="isGroupExpanded(entry.id)">
                            <button
                                type="button"
                                class="nav-item nav-group-header"
                                [class.has-active-child]="isCurrentRouteInGroup(entry.id)"
                                (click)="toggleGroup(entry.id)"
                                [matTooltip]="!isExpanded() ? entry.label : ''"
                                matTooltipPosition="right">
                                <mat-icon>{{ entry.icon }}</mat-icon>
                                <span class="nav-label">{{ entry.label }}</span>
                                <mat-icon class="nav-chevron">expand_more</mat-icon>
                            </button>

                            <!-- Hijos: solo se muestran cuando (a) el sidebar
                                 está expandido (en colapsado los hijos no se
                                 ven) Y (b) el grupo en particular está expandido
                                 (por click del usuario o porque la ruta actual
                                 es un hijo del grupo). -->
                            @if (isExpanded() && isGroupExpanded(entry.id)) {
                                <div class="nav-group-children">
                                    @for (child of entry.children; track child.id) {
                                        @if (child.children?.length) {
                                            <!-- Sub-grupo (Inventario): despliega sus opciones -->
                                            <button
                                                type="button"
                                                class="nav-item nav-child nav-sub-header"
                                                [class.has-active-child]="isItemActive(child)"
                                                [class.open]="isSubExpanded(child)"
                                                [attr.aria-expanded]="isSubExpanded(child)"
                                                (click)="toggleSub(child)">
                                                <mat-icon>{{ child.icon }}</mat-icon>
                                                <span class="nav-label">{{ child.label }}</span>
                                                <mat-icon class="nav-chevron">expand_more</mat-icon>
                                            </button>
                                            @if (isSubExpanded(child)) {
                                                @for (sub of child.children; track sub.id) {
                                                    <button
                                                        type="button"
                                                        class="nav-item nav-child nav-subchild"
                                                        [class.active]="isActive(sub.route)"
                                                        (click)="navigateTo(sub.route)">
                                                        <span class="nav-label">{{ sub.label }}</span>
                                                    </button>
                                                }
                                            }
                                        } @else {
                                            <button
                                                type="button"
                                                class="nav-item nav-child"
                                                [class.active]="isActive(child.route)"
                                                (click)="navigateTo(child.route)">
                                                <mat-icon>{{ child.icon }}</mat-icon>
                                                <span class="nav-label">{{ child.label }}</span>
                                            </button>
                                        }
                                    }
                                </div>
                            }
                        </div>
                    } @else if (entry.children?.length) {
                        <!-- Leaf con hijos (Catálogos): el item lleva al menú de
                             catálogos y la flecha despliega sus catálogos. -->
                        <div class="nav-group" [class.expanded]="isLeafExpanded(entry)">
                            <button
                                type="button"
                                class="nav-item nav-group-header"
                                [class.active]="isActive(entry.route) && !isLeafExpanded(entry)"
                                [class.has-active-child]="isActive(entry.route)"
                                (click)="navigateTo(entry.route)"
                                [matTooltip]="!isExpanded() ? entry.label : ''"
                                matTooltipPosition="right">
                                <mat-icon>{{ entry.icon }}</mat-icon>
                                <span class="nav-label">{{ entry.label }}</span>
                                <span class="nav-chevron-hit" role="button" tabindex="0"
                                      [attr.aria-label]="isLeafExpanded(entry) ? 'Ocultar catálogos' : 'Ver catálogos'"
                                      (click)="toggleLeaf(entry, $event)" (keydown.enter)="toggleLeaf(entry, $event)">
                                    <mat-icon class="nav-chevron">expand_more</mat-icon>
                                </span>
                            </button>
                            @if (isExpanded() && isLeafExpanded(entry)) {
                                <div class="nav-group-children">
                                    @for (child of entry.children; track child.id) {
                                        <button
                                            type="button"
                                            class="nav-item nav-child"
                                            [class.active]="isActive(child.route)"
                                            (click)="navigateTo(child.route)">
                                            <mat-icon>{{ child.icon }}</mat-icon>
                                            <span class="nav-label">{{ child.label }}</span>
                                        </button>
                                    }
                                </div>
                            }
                        </div>
                    } @else {
                        <!-- Item top-level (leaf) normal -->
                        <button
                            type="button"
                            class="nav-item"
                            [class.active]="isActive(entry.route)"
                            [class.disabled]="entry.disabled"
                            [disabled]="entry.disabled"
                            (click)="navigateTo(entry.route)"
                            [matTooltip]="!isExpanded() ? entry.label : ''"
                            matTooltipPosition="right">
                            <mat-icon>{{ entry.icon }}</mat-icon>
                            <span class="nav-label">{{ entry.label }}</span>
                        </button>
                    }
                }
            }
        </nav>

        <!-- User profile -->
        <div class="sidebar-footer">
            <button type="button"
                    class="user-card"
                    [matMenuTriggerFor]="userMenu"
                    [matTooltip]="!isExpanded() ? userName() : ''"
                    matTooltipPosition="right">
                <div class="user-avatar">
                    @if (userImage()) {
                        <img [src]="userImage()" alt="avatar" />
                    } @else {
                        <mat-icon>person</mat-icon>
                    }
                </div>
                <div class="user-info">
                    <div class="user-name">{{ userName() }}</div>
                    <div class="user-role" [class.no-role]="!userRole()">
                        {{ userRoleName() }}
                    </div>
                </div>
                <mat-icon class="user-chevron">expand_more</mat-icon>
            </button>

            <mat-menu #userMenu="matMenu" xPosition="before">
                <button mat-menu-item (click)="openProfile()">
                    <mat-icon>account_circle</mat-icon>
                    <span>Mi perfil</span>
                </button>
                <button mat-menu-item (click)="logout()">
                    <mat-icon>logout</mat-icon>
                    <span>Cerrar sesión</span>
                </button>
            </mat-menu>

            <div class="version-tag">{{ appVersion }}</div>
        </div>
    </aside>

    <!-- ========== CONTENIDO DINÁMICO ========== -->
    <div class="content-wrapper">
        <!-- El contenido se monta cuando ya se conoce el rol (sus permisos). -->
        @if (menuReady()) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Pantalla de carga mientras llegan el usuario, su rol y los módulos. -->
    @if (!menuReady()) {
        <div class="app-loading" role="status" aria-live="polite">
            <img src="assets/images/logo_epione_colors.png" alt="Epione" class="app-loading__logo" />
            <mat-spinner diameter="36"></mat-spinner>
            <span class="app-loading__text">Cargando tu perfil…</span>
            @if (loadingSlow()) {
                <span class="app-loading__slow">Está tardando más de lo normal. Revisa tu conexión.</span>
                <button mat-stroked-button color="primary" (click)="reloadApp()">
                    <mat-icon>refresh</mat-icon> Reintentar
                </button>
            }
        </div>
    }

    <!-- ── Notificaciones (todos los tamaños) ─────────────────────────── -->
    <button type="button" class="notif-bell" [matMenuTriggerFor]="notifMenu" matTooltip="Notificaciones"
            (menuOpened)="loadTicketNotifs()">
        <mat-icon [matBadge]="ticketNotifs().length || null" matBadgeColor="warn" matBadgeSize="small">notifications</mat-icon>
    </button>
    <mat-menu #notifMenu="matMenu" xPosition="before" class="notif-panel">
        @if (ticketNotifs().length === 0) {
            <div class="notif-empty" (click)="$event.stopPropagation()">
                <mat-icon>notifications_off</mat-icon>
                <p>No hay notificaciones por el momento</p>
            </div>
        } @else {
            <div class="notif-title" (click)="$event.stopPropagation()">Tickets asignados a ti</div>
            @for (n of ticketNotifs(); track n.id) {
                <button mat-menu-item class="notif-item" (click)="openTicketsFromNotif()">
                    <mat-icon>confirmation_number</mat-icon>
                    <span class="notif-item__text">
                        <b>{{ n.folio }}</b> · {{ n.subject }}
                        <small>{{ n.status }}{{ n.priority ? ' · ' + n.priority : '' }}</small>
                    </span>
                </button>
            }
        }
    </mat-menu>

    <!-- ── Navegación móvil: barra flotante estilo app ────────────────── -->
    <nav class="mobile-bar">
        <button type="button" [class.active]="isActive('/dashboard')" (click)="mobileNavigate('/dashboard')" aria-label="Inicio">
            <mat-icon>home</mat-icon>
        </button>
        <button type="button" [class.active]="mobileSearchOpen()" (click)="toggleMobileSearch()" aria-label="Buscar">
            <mat-icon>search</mat-icon>
        </button>
        <button type="button" [class.active]="mobileMenuOpen()" (click)="toggleMobileMenu()" aria-label="Menú">
            <mat-icon>menu</mat-icon>
        </button>
        <button type="button" [matMenuTriggerFor]="userMenu" aria-label="Mi perfil" class="mobile-avatar">
            @if (userImage()) {
                <img [src]="userImage()" alt="avatar" />
            } @else {
                <mat-icon>account_circle</mat-icon>
            }
        </button>
    </nav>

    <!-- Buscador móvil: lanzador rápido de pantallas -->
    @if (mobileSearchOpen()) {
        <div class="mobile-overlay" (click)="toggleMobileSearch()">
            <div class="mobile-sheet" (click)="$event.stopPropagation()">
                <div class="mobile-sheet__search">
                    <mat-icon>search</mat-icon>
                    <input type="text" placeholder="Buscar pantalla..." autofocus
                           [value]="mobileSearchTerm()" (input)="onMobileSearchInput($event)" />
                </div>
                <div class="mobile-sheet__list">
                    @for (leaf of filteredLeaves(); track leaf.id) {
                        <button type="button" (click)="mobileNavigate(leaf.route)">
                            <mat-icon>{{ leaf.icon }}</mat-icon>
                            <span>{{ leaf.label }}</span>
                        </button>
                    } @empty {
                        <p class="mobile-sheet__empty">Sin coincidencias</p>
                    }
                </div>
            </div>
        </div>
    }

    <!-- Menú hamburguesa móvil: todos los módulos -->
    @if (mobileMenuOpen()) {
        <div class="mobile-overlay" (click)="toggleMobileMenu()">
            <div class="mobile-sheet" (click)="$event.stopPropagation()">
                <div class="mobile-sheet__title">Módulos</div>
                <div class="mobile-sheet__list">
                    @for (entry of visibleModules(); track entry.id) {
                        @if (isGroup(entry)) {
                            <div class="mobile-sheet__group">{{ entry.label }}</div>
                            @for (child of entry.children; track child.id) {
                                @if (child.children?.length) {
                                    <div class="mobile-sheet__group indent">{{ child.label }}</div>
                                    @for (sub of child.children; track sub.id) {
                                        <button type="button" class="indent2" [class.active]="isActive(sub.route!)" (click)="mobileNavigate(sub.route)">
                                            <mat-icon>{{ sub.icon }}</mat-icon>
                                            <span>{{ sub.label }}</span>
                                        </button>
                                    }
                                } @else {
                                    <button type="button" class="indent" [class.active]="isActive(child.route!)" (click)="mobileNavigate(child.route)">
                                        <mat-icon>{{ child.icon }}</mat-icon>
                                        <span>{{ child.label }}</span>
                                    </button>
                                }
                            }
                        } @else {
                            <button type="button" [class.active]="isActive(entry.route!)" (click)="mobileNavigate(entry.route)">
                                <mat-icon>{{ entry.icon }}</mat-icon>
                                <span>{{ entry.label }}</span>
                            </button>
                            <!-- Catálogos en móvil: sus catálogos, indentados debajo. -->
                            @for (child of entry.children ?? []; track child.id) {
                                <button type="button" class="indent" [class.active]="isActive(child.route!)" (click)="mobileNavigate(child.route)">
                                    <mat-icon>{{ child.icon }}</mat-icon>
                                    <span>{{ child.label }}</span>
                                </button>
                            }
                        }
                    }
                </div>
            </div>
        </div>
    }
</div>